import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from "@chakra-ui/react";
import { BiBadgeCheck } from "react-icons/bi";
import { IoCloseOutline } from "react-icons/io5";
import { useManajemenPengetahuanPendaftarDetailContext } from "../../../controller/admin/manajemen_pengetahuan/pendaftar/detail";

interface ModalApprovePendaftarProps {
    pengetahuan_id: string;
    id: string;
    mode?: "approve" | "revisi";
}

const ModalApprovePendaftar = ({ pengetahuan_id, id, mode = "approve" }: ModalApprovePendaftarProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const { handleApprove } =
        useManajemenPengetahuanPendaftarDetailContext().dispatch;

    const { isLoadingAction } =
        useManajemenPengetahuanPendaftarDetailContext().state;

    const buttonLabel = mode === "approve" ? "Terima" : "Revisi";

    return (
        <>
            <Button colorScheme={mode === "approve" ? "green" : "yellow"} color="white" ml={2} onClick={onOpen}>
                {buttonLabel}
            </Button>

            <Modal isOpen={isOpen} onClose={onClose} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Button
                            onClick={onClose}
                            position="absolute"
                            top={2}
                            right={2}
                            colorScheme="red"
                            size="sm"
                            borderRadius="md"
                            p={0}
                            minW="28px"
                            h="28px"
                        >
                            <IoCloseOutline size={18} />
                        </Button>
                    </ModalHeader>

                    {mode === 'approve' ? (
                        <>
                            <Flex justify="center" mt={4}>
                                <Flex
                                    bg="green.500"
                                    borderRadius="full"
                                    w="50px"
                                    h="50px"
                                    align="center"
                                    justify="center"
                                >
                                    <BiBadgeCheck color="white" size={24} />
                                </Flex>
                            </Flex>

                            <ModalBody textAlign="center"
                                fontSize="md"
                                fontWeight="semibold"
                                mt={3}
                            >
                                Apakah anda ingin menerima pengajuan ini?
                            </ModalBody>

                            <ModalFooter justifyContent="center" gap={3}>
                                <Button bg="gray.500" color="white" mr={2} onClick={onClose}>
                                    Batal
                                </Button>
                                <Button
                                    colorScheme="green"
                                    disabled={isLoadingAction}
                                    isLoading={isLoadingAction}
                                    onClick={() => handleApprove(Number(pengetahuan_id), Number(id), onClose)}
                                >
                                    Ya
                                </Button>
                            </ModalFooter>
                        </>
                    ) : (
                        <>
                            <ModalBody textAlign="center"
                                fontSize="md"
                                fontWeight="semibold"
                                mt={3}
                            >
                                Anda akan mengubah hasil verifikasi pendaftaran. Apakah Anda ingin melanjutkan?
                            </ModalBody>

                            <ModalFooter justifyContent="center" gap={3}>
                                <Button
                                    colorScheme="green"
                                    disabled={isLoadingAction}
                                    isLoading={isLoadingAction}
                                    onClick={() => handleApprove(Number(pengetahuan_id), Number(id), onClose)}
                                >
                                    Ya, Lanjutkan
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
};

export default ModalApprovePendaftar;
